<template>
  <div class="app-container material">
    <div class="material-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="material-filter-value" v-model.trim="filter.name" @keyup.enter.native="clickFilterBtn" placeholder="文件名称" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-cascader 
                       class="material-filter-value"
                       v-model.trim="filter.tag"
                       :options="tagCascadeList"
                       :props="tagOptionProps"
                       @change="clickFilterBtn"
                       :show-all-levels="false"
                       clearable
                       filterable
                       size="small"
                       placeholder="请输入或选择素材标签">
          </el-cascader>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <el-button class="material-filter-reset" size="small" @click="clickClearBtn">清除条件</el-button>
            <el-button class="material-filter-search" size="small" @click="clickFilterBtn">立即筛选</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <basic-container>
      <div class="material-body">
        <div class="material-body-left">
          <div class="material-body-left-type-header header-common">素材类型</div>
          <div class="material-body-left-type-body">
            <el-menu default-active="0" class="el-menu-vertical-demo" @select="handleTypeSelect">
              <el-menu-item index="0">
                <span slot="title">全部</span>
              </el-menu-item>
              <el-menu-item index="1">
                <span slot="title">图片</span>
              </el-menu-item>
              <el-menu-item index="2">
                <span slot="title">视频</span>
              </el-menu-item>
              <el-menu-item index="3">
                <span slot="title">音频</span>
              </el-menu-item>
              <el-menu-item index="4">
                <span slot="title">文档</span>
              </el-menu-item>
            </el-menu>
          </div>
        </div>
        <div class="material-body-right" v-loading="isUploading">
          <div class="material-body-right-header header-common">全部</div>
          <div class="material-body-right-operation">
            <el-upload class="material-body-right-upload" multiple :show-file-list="false" :before-upload="handleBeforeUpload" :http-request="handleHttpRequest">
              <el-button type="primary" size="small" :loading="isUploading">{{ isUploading ? '上传中' : '上传素材' }}</el-button>
            </el-upload>
            <el-button type="primary" size="small" @click="clickDeleteBtn"><i class="el-icon-delete"></i> 删除</el-button>
          </div>
          <div class="material-body-right-body">
            <avue-crud :table-loading="listLoading" :data="list" :option="option" :page.sync="page" @on-load="onLoad" @select="handleSelect" @select-all="handleSelectAll" @sort-change="handleSortChange">
              <template slot="name" slot-scope="scope">
                <div class="material-name" v-if="['picture', 'video'].includes(getMaterialType(scope.row.name).type)">
                  <div class="cover-image" v-if="scope.row.coverUrl" v-viewer>
                    <img :src="scope.row.coverUrl">
                  </div>
                  <span style="color:#5383F3;" class="click" @click="preview(scope.row)">{{scope.row.name}}</span>
                </div>
                <div class="material-name" :title="scope.row.name" v-else>
                   <div class="cover-image">
                    <img :src="getMaterialType(scope.row.name).src | ossImageProcess"/>
                   </div>
                  <span style="color:#5383F3;" class="click" @click="preview(scope.row)">{{scope.row.name}}</span>
                </div>
              </template>
              <template slot="tagName" slot-scope="scope">
                <div class="material-tag-name" :title="scope.row.tagName">
                  <el-button v-if="!scope.row.tagName" type="text" size="small" icon="el-icon-plus" @click="handleAddMaterialTag(scope.row,scope.index)">添加标签</el-button>
                  <el-button v-if="scope.row.tagName" type="text" size="small" @click="handleEditMaterialTag(scope.row,scope.index)">{{scope.row.tagName}}</el-button>
                </div>
              </template>
              <template slot-scope="scope" slot="menu">
                <div class="row-operation">
                  <button class="row-menu" @click="download(scope.row)">
                    <i class="icon-download"></i>
                    下载
                  </button>
                  <button class="row-menu" @click="deleteOne(scope.row)">
                    <i class="el-icon-delete"></i>
                    删除
                  </button>
                  <el-button
                    title="复制链接"
                    size="mini"
                    type="text"
                    icon="el-icon-share"
                    @click="copyLink(scope.row)">复制链接
                  </el-button>
                </div>
              </template>
            </avue-crud>
          </div>
        </div>
      </div>
    </basic-container>
    <el-dialog title="添加标签"
               :visible.sync="addMaterialTagDialog"
               width="30%"
               class="handle-dialog">
      <el-form ref="tagFrom" :model="tagFrom">
        <el-form-item prop="tagId">
          <el-cascader v-model="tagFrom.tagId"
                       :options="tagCascadeList"
                       :props="tagOptionProps"
                       :show-all-levels="false"
                       filterable
                       size="small"
                       placeholder="-请选择素材标签-">
          </el-cascader>
        </el-form-item>
        <div class="handle-dialog-footer">
          <el-button type="primary" class="handle-dialog-footer-save" @click="addMaterialTag">确定</el-button>
          <el-button class="handle-dialog-footer-cancel" @click="closeDialogHandleTag">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog title="修改标签"
               :visible.sync="editMaterialTagDialog"
               width="30%"
               class="handle-dialog">
      <el-form ref="tagFrom" :model="tagFrom">
        <el-form-item prop="tagId">
          <el-cascader v-model="tagFrom.tagId"
                       :options="tagCascadeList"
                       :props="tagOptionProps"
                       :show-all-levels="false"
                       filterable
                       size="small"
                       placeholder="-请选择素材标签-">
          </el-cascader>
        </el-form-item>
        <div class="handle-dialog-footer">
          <el-button type="primary" class="handle-dialog-footer-save" @click="editMaterialTag">确定</el-button>
          <el-button class="handle-dialog-footer-cancel" @click="closeDialogHandleTag">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { saveAs } from 'file-saver'
import { imageBase64ToUint8Array } from '@/util/util'
import { tableOption, materialType, materialTypeList } from '@/const/crud/material/material'
import { getMaterialList, addMaterial, deleteMaterial, addMaterialTagObj } from '@/api/material/material'
import { getTagRelationList } from '@/api/material/tag'
import { getFileNameUUID, getOSSFileMaterial } from '@/api/basic/aliyunoss';
import uploadService from '@/common/common-logic/upload-service';

export default {
  data() {
    return {
      materialTypeList: materialTypeList,
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      // 筛选条件
      filter: {
        // 文件类型
        type: null,
        // 文件名
        name: '',
        // 标签名
        tag: [],
        sortField: 'inserted_time',
        sortPolicy: 'desc',
      },
      listLoading: true,
      isUploading: false,
      list: [],
      selectedList: [],
      addMaterialTagDialog: false,
      editMaterialTagDialog: false,
      option:tableOption,
      tagCascadeList: [],
      tagOptionProps:{
        value : 'id',
        label : 'tagName',
        children : 'tagList',
      },
      tagFrom: {
        id: 0,
        tagId : [],
      },
      canUploadImageFormat: ['image/jpeg', 'image/png', 'image/gif'],
    }
  },
  activated: async function() {
    this.loadTagCascadeList();
  },
  created: async function() {
    this.materialTypeList.forEach((material) => {
      material.src = require('../../static/images/material/material_' + material.type + '.svg');
    });
  },
  methods: {
    async loadTagCascadeList() {
      const response = await getTagRelationList();
      this.tagCascadeList = response.data.data;
    },
    async baseGetMaterialList() {
      this.listLoading = true;
      const params = {};
      params.size = this.page.pageSize;
      params.current = this.page.currentPage;
      params.type = this.filter.type;
      params.name = this.filter.name;
      var arr = this.filter.tag;
      params.tagId = arr[arr.length-1];

      if(this.filter.sortField !== "" && this.filter.sortField.trim() !== "")
        params.sortField = this.filter.sortField;
      else
        params.sortField="inserted_time";
      if(this.filter.sortPolicy !== "" && this.filter.sortPolicy.trim() !== "")
        params.sortPolicy = this.filter.sortPolicy;
      else
        params.sortPolicy="desc";

      const response = await getMaterialList(params);

      this.list = response.data.data.records;
      this.list.forEach(item => {
        item.checked = false;
      });
      this.page.total = response.data.data.total;
      this.listLoading = false;
    },
    onLoad(page) {
      this.page.pageSize = page.pageSize;
      this.page.currentPage = page.currentPage;
      this.baseGetMaterialList(page);
    },
    handleSelect (selection, row) {
      this.selectedList = selection;
    },
    handleSelectAll (selection) {
      this.selectedList = selection;
    },
    handleSortChange(val) {
      if (val.prop == "insertedTime") {
        this.filter.sortField = "inserted_time";
      } else {
        this.filter.sortField = "";
      }
      // 检查排序方式
      if (val.order == 'ascending') {
        this.filter.sortPolicy = "asc";
      } else if (val.order == 'descending') {
        this.filter.sortPolicy = "desc";
      } else {
        this.filter.sortPolicy = "";
      }
      this.baseGetMaterialList();
    },
    clickDeleteBtn () {
      if (this.selectedList.length === 0) {
        this.$message.info('您还没有选择要删除的素材');
        return;
      }
      this.$confirm('此操作将永久删除这些素材, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const ids = this.selectedList.map(item => item.id);
        await deleteMaterial(ids.join(','));
        this.$message.success('删除成功');
        this.baseGetMaterialList();
      });
    },
    getMaterialType(name) {
      const extension = name.substr(name.lastIndexOf('.') + 1).toLowerCase();
      for (const materialType of this.materialTypeList) {
        const extensions = materialType.extensions;
        const index = extensions.indexOf(extension);
        if (index !== -1) {
          return materialType;
        }
      }
      return this.materialTypeList.find(materialType => materialType.type === 'document');
    },
    handleBeforeUpload (file) {
      if (file.type.indexOf('image') !== -1 && !this.canUploadImageFormat.includes(file.type)) {
        this.$message.info('上传失败，图片素材上传仅支持jpg,jpeg,png,gif格式');
        return false;
      }
      if (this.isUploading) return;

      if (file.name.length > 45) {
        this.$message({
          type: 'info',
          duration: 0,
          showClose: true,
          message: `[${file.name}]名称过长，不能超过45个字符`
        })
        return false;
      }
      return true;
    },
    getObjectURL(file) {
      let url = null;
      if (window.createObjectURL !== undefined) {
        // basic
        url = window.createObjectURL(file);
      } else if (window.URL !== undefined) {
        // mozilla(firefox)
        url = window.URL.createObjectURL(file);
      } else if (window.webkitURL !== undefined) {
        // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
      }
      return url;
    },
    async generatorVideoCoverImage(videoFile) {
      return new Promise((resolve, reject) => {
        let videoElement = document.createElement('video');
        const blob = new Blob([videoFile], {type: videoFile.type.toLowerCase()});
        const videoUrl = this.getObjectURL(blob);
        videoElement.setAttribute('x-webkit-airplay', '');
        videoElement.setAttribute('webkit-playsinline', '');
        videoElement.setAttribute('x5-playsinline', '');
        videoElement.setAttribute('playsinline', '');
        videoElement.setAttribute('x-webkit-airplay', '');
        videoElement.setAttribute('src', videoUrl);
        videoElement.muted = true;

        videoElement.addEventListener('loadeddata', async () => {
            const canvas = document.createElement('canvas');
            canvas.width = videoElement.videoWidth;
            canvas.height = videoElement.videoHeight;
            canvas
              .getContext('2d')
              .drawImage(videoElement, 0, 0, canvas.width, canvas.height);
            videoElement.setAttribute('src', null);
            window.URL.revokeObjectURL(videoUrl);
            videoElement = null;

            const b64Image = canvas.toDataURL('image/jpeg', 0.4);
            const u8Image = imageBase64ToUint8Array(b64Image);
            const key = `${getOSSFileMaterial() + getFileNameUUID()}.jpg`;
            const file = new Blob([u8Image], { type: 'image/jpg' });
            resolve({
              file,
              key,
            });
          }, { once: true }
        );

        videoElement.load();
        videoElement.play();
      });
    },
    async handleHttpRequest (data) {
      try {
        const uploadFiles = [];
        const file = data.file;
        const fileKey = getOSSFileMaterial() + getFileNameUUID() + file.name.substr(file.name.lastIndexOf("."));

        const type = this.getMaterialType(file.name).value;
        let coverKey = null;
        const contentKey = fileKey;
        if (type === materialType.VIDEO) {
          this.isUploading = true;
          const coverImage = await this.generatorVideoCoverImage(file);
          uploadFiles.push({
            key: coverImage.key,
            file: coverImage.file,
          });
          coverKey = coverImage.key
        }

        uploadFiles.push({
          key: fileKey,
          file: file,
        });

        const material = {
          name: file.name,
          size: file.size,
          type: type,
        }

        const response = await uploadService.uploadFiles(uploadFiles);
        const contentFile = response.find(item => item.key === contentKey);
        material.contentUrl = contentFile.fileUrl;
        if (coverKey) {
          const coverImage = response.find(item => item.key === coverKey);
          material.coverUrl = coverImage.fileUrl;
        } else {
          material.coverUrl = material.contentUrl;
        }
        if (this.filter.tag) {
          const arr = this.filter.tag;
          material.tagId = arr[arr.length-1];
        }

        await addMaterial(material);
        this.isUploading = false;
        this.$message({
          type: 'success',
          message: `上传成功[${file.name}]`
        });
        this.baseGetMaterialList();
      } catch (error) {
        this.isUploading = false;
        this.$message({
          type: 'error',
          duration: 0,
          showClose: true,
          message: `上传失败，请重试[${file.name}]`
        })
      }
    },
    handleTypeSelect (index) {
      const searchType = (index === '0' ? null : index);
      if (searchType === this.filter.type) {
        return;
      }
      this.filter.type = searchType;
      this.filter.name = '';
      this.page.currentPage = 1;
      this.baseGetMaterialList();
    },
    clickClearBtn () {
      this.filter.name = '';
      this.filter.tag = [];
      this.page.currentPage = 1;
      this.baseGetMaterialList();
    },
    clickFilterBtn () {
      this.page.currentPage = 1;
      this.baseGetMaterialList();
    },
    handleAddMaterialTag (row,index) {
      this.addMaterialTagDialog = true;
      this.tagFrom.tagId = [];
      this.tagFrom.id = row.id;
    },
    addMaterialTag () {
      const params = {};
      params.id = this.tagFrom.id;
      var arr = this.tagFrom.tagId
      params.tagId = arr[arr.length-1];
      addMaterialTagObj(params).then(() => {
        this.baseGetMaterialList();
        this.addMaterialTagDialog = false;
        this.$notify({
          title: '成功',
          message: '添加成功',
          type: 'success',
          duration: 2000
        });
      });
    },
    closeDialogHandleTag () {
      this.addMaterialTagDialog = false;
      this.editMaterialTagDialog = false;
      this.tagFrom.tagId = [];
    },
    handleEditMaterialTag (row,index) {
      this.editMaterialTagDialog = true;
      this.tagFrom.id = row.id;
      this.tagFrom.tagId = [row.groupId,row.tagId];
    },
    editMaterialTag () {
      const params = {};
      params.id = this.tagFrom.id;
      var arr = this.tagFrom.tagId
      params.tagId = arr[arr.length-1];
      addMaterialTagObj(params).then(() => {
        this.baseGetMaterialList();
        this.editMaterialTagDialog = false;
        this.$notify({
          title: '成功',
          message: '修改成功',
          type: 'success',
          duration: 2000
        });
      });
    },
    preview (row) {
      let url;
      if (row.type === materialType.PICTURE) {
        url = row.coverUrl;
      } else {
        url = row.contentUrl;
      }
      window.open(url);
    },
    download (row) {
      const FileSaver = require('file-saver');
      FileSaver.saveAs(row.contentUrl, row.name);
    },
    deleteOne (row) {
      this.$confirm(`此操作将永久删除 ${row.name}, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        await deleteMaterial(row.id);
        this.$message.success('删除成功');
        this.baseGetMaterialList();
      });
    },
    async copyLink (row) {
      await this.$copyText(row.contentUrl);
      this.$message.success('已复制素材链接到剪切板');
    }
  }
}
</script>

<style lang="scss" scoped>
.material {
  &-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      border: none;
      font-size: 14px;
    }
    .el-row {
      width: 95%;
    }
    &-value {
      width: calc(100% - 12px) !important;
    }
    &-reset {
      margin-left: 10px;
    }
    &-search {
      margin-left: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }

  &-container {
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 170px;
      text-align: left;
    }
  }
}
/deep/ .el-checkbox {
  .is-focus .el-checkbox__inner {
    border-color: #dcdfe6;
  }
}
i[class^='icon'] {
  background-size: 12px 12px;
}
.icon-download {
  background-image: url("../../static/images/material/icon-download.png");
}
.icon-link {
  background-image: url("../../static/images/material/icon-link.png");
}
.click {
  cursor: pointer;
}
.material-header {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  &-filter {
    display: flex;
    justify-content: space-between;

    .el-button+ .el-button {
      margin: 0px;
    }
    &-search {
      margin-left: 8px;
      border-color: #5383f3;
      color: #5383f3;
    }
    &-reset {
      margin-left: 20px;
      margin-right: 8px;
    }
  }
}
.material-body {
  margin-top: 8px;
  display: flex;
  .header-common {
    padding-left: 10px;
    line-height: 50px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 600;
    color: #3b3b3b;
  }
  &-left {
    flex: 1;
  }
  &-right {
    flex: 9;
    padding-left: 20px;
    &-upload {
      display: inline;
      margin-right: 10px;
    }
    &-body {
      /deep/ .avue-crud {
        margin: 0 0;
        .avue-crud__menu {
          display: none;
        }
        .avue-crud__box .el-card__body,
        .avue-crud__box .el-card__header {
          padding-top: 0;
        }
        .avue-crud__tip {
          display: none;
        }
      }
      .material-name {
        display: flex;
        align-items: center;
        padding: 8px 0;
        .cover-image {
          display: flex;
          width: fit-content;
          margin-right: 12px;
          cursor: pointer;
          img {
            width: 40px;
            height: 40px;
            object-fit: cover;
            max-width: 100%;
          }
        }
      }
      .row-operation {
        display: flex;
        .row-menu {
          display: flex;
          align-items: center;
          font-size: 12px;
          border: none;
          color: #409EFF;
          background: transparent;
          i {
            width: 13px;
            height: 13px;
            margin-right: 2px;
          }
        }
      }
    }
  }
}
.handle-dialog {
  display: flex;
  flex-direction: column;
  &-footer{
    display: flex;
    flex-direction: row;
    padding: 50px 0px;
    &-save {
      padding: 8px 12px;
      position: absolute;
      right: 90px;
    }
    &-cancel {
      padding: 8px 12px;
      position: absolute;
      right: 10px;
      margin-right: 10px;
    }
  }
}
</style>
